import BlockSlider from "../components/block-slider";

export default class ModelBlock {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const modelsCategorySelect = document.querySelector('.models__category__select select');
        const modelSliderSkeleton = document.querySelector('#model__slider__skeleton');
        if (modelsCategorySelect) {
            modelsCategorySelect.onchange = () => {
                let category = modelsCategorySelect.value;
                const modelSlider = document.querySelector('.block-slider');
                modelSlider.style.display = 'none';
                modelSliderSkeleton.classList.add('active');
                this.fetchModels(category).then(response => {
                    modelSlider.innerHTML = '';
                    modelSlider.innerHTML = response['block'];
                    modelSliderSkeleton.classList.remove('active');
                    modelSlider.style.display = 'block';
                    new BlockSlider();
                }).catch(error => {
                    modelSlider.style.display = 'block';
                    modelSliderSkeleton.classList.remove('active');
                });
            }
        }
    }

    async fetchModels(id) {
        let origin = window.location.origin;
        let url = `${origin}/wp-json/royalhomes/v1/model-block/${id}`;

        const response = await fetch(url);

        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        if (!response.ok) {
            const message = `An error has occurred fetching the models: ${response.status}`;
            throw new Error(message);
        }
        return data;
    }
}